import { useNavigate } from 'react-router-dom';
import { Button3D, type Button3DSize } from '@/components/ui/button-3d';
import { ReceiptText } from 'lucide-react';
import type { ReceiptPrefill } from '@/hooks/useReceipts';
import type { ReceiptRouteState } from '@/pages/ReceiptFormPage';

interface GenerateReceiptButtonProps {
  /** Seed values for the new receipt — one of the 4 origins. */
  prefill: ReceiptPrefill;
  label?: string;
  className?: string;
  size?: Button3DSize;
}

/**
 * Reusable "Gerar recibo" entry point. Navigates to the receipt form pre-filled
 * from the origin (quote / service order / finance entry). NEVER creates
 * automatically — the user always confirms in the form, which then goes to the
 * new receipt.
 *
 * Era um MODAL aberto aqui mesmo; virou navegação quando o formulário virou rota
 * (`/recibos/novo`). O prefill viaja no STATE da navegação porque é um objeto —
 * e, diferente do `ownerQuoteId` do financeiro (#164), ele é conveniência, não
 * autorização: o recibo não altera nenhum outro documento.
 */
export function GenerateReceiptButton({
  prefill,
  label = 'Gerar recibo',
  className,
  size = 'default',
}: GenerateReceiptButtonProps) {
  const navigate = useNavigate();

  return (
    <Button3D
      type="button"
      size={size}
      className={className}
      onClick={() => navigate('/recibos/novo', { state: { prefill } satisfies ReceiptRouteState })}
    >
      <ReceiptText className="mr-2 h-4 w-4" />
      {label}
    </Button3D>
  );
}
